import { graphql, HttpResponse } from 'msw'
import { type EnrollmentFilingStatusData, type EnrollmentFilingStatusSubmitOutput } from '../../../models'

export const getEnrollmentFilingStatusDataMock: EnrollmentFilingStatusData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/filing-status',
  enrollmentData: {
    userInfo: {
      income: 10000,
    },
  },
}

export const submitEnrollmentFilingStatusDataMock: EnrollmentFilingStatusSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/investment-goals',
}

export const mockGetEnrollmentFilingStatusData = graphql.mutation('getEnrollmentFilingStatusData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentFilingStatusDataMock } })
})

export const mockSubmitEnrollmentFilingStatusData = graphql.mutation('submitEnrollmentFilingStatusData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentFilingStatusDataMock } })
})

export const mockEnrollmentFilingStatus = [mockGetEnrollmentFilingStatusData, mockSubmitEnrollmentFilingStatusData]
